import React, { useState, useEffect } from "react";
import ManageUrls from "../endpoints/manage_urls";
import config from '../env-config.json';
import { history } from "../history";
import { useContext } from "react";
import { AuthContext } from "../state";

function AddAgentForm() {
  const [formData, setFormData] = useState({});
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const { state } = useContext(AuthContext);

  const countryId = state.profile.data.relationships.country.data.id;
  const countryDetails = state.countries.filter(country => country.id === countryId);
  const mobile_prefix_value = countryDetails.length === 0 ? "263" : countryDetails[0].attributes.phone_prefix;

  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);

    const payload = {
      data: {
        attributes: {
          email: formData.email,
          first_name: formData.first_name,
          last_name: formData.last_name,
          middle_name: !formData.middle_name ? "" : formData.middle_name,
          mobile: [
            formData.mobile_prefix,
            formData.mobile_number
          ]
        },
        id: null,
        relationships: {
          cash_pickup_location: {
            data: {
              id: formData.location,
              type: "cash_pickup_locations"
            }
          },
          country: {
            data: {
              id: state.profile.data.relationships.country.data.id,
              type: "countries"
            }
          }
        },
        type: "cash_pickup_agents"
      }
    }
    setLoading(true);

    fetch(manageUrls.getApiUrl() + 'cash_pickup_agents/', {
            mode: 'cors',
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/vnd.api+json',
                'Accept': 'application/vnd.api+json',
                'Authorization': 'Bearer ' + state.accessToken,
                'App-Id': config.app_id,
            },
            body: JSON.stringify(payload),
        })
        .then(res => {
          if (res.status >= 400) {
              res.json().then(res => {
                if(res.hasOwnProperty("errors")) {
                  if(res.errors.length > 0) {
                    window.alert(res.errors[0].detail);
                  }
                } else {
                  window.alert("Failed to add agent.");
                }
              });
              setLoading(false);
              return Promise.reject("Failed to add agent.");
          } else if(res.status >= 200 || res.status < 300) {
            window.alert("Agent added successfully.");
            setFormData({
              first_name: "",
              last_name: "",
              middle_name: "",
              email: "",
              mobile_prefix: mobile_prefix_value,
              mobile_number: "",
              location: "",
            })
            setLoading(false);
          }

          return res;
        })
        .then(res => res.json())
        .then(res => console.log("agent created", res))
  }

  const manageUrls = new ManageUrls();

  useEffect(() => {
    // manageUrls.baseCountryIsSA()
    setFormData({...formData, mobile_prefix: mobile_prefix_value});
  }, [manageUrls.baseCountryIsSA()]);

  useEffect(() => {
    let formatLocations = state.cashPickupLocations;

    formatLocations.unshift({key: "Please select location", value: ""});
    setLocations(formatLocations);
    
  }, [state.cashPickupLocations]);

  return (
    <div className="our-causes pt-0">
      <div className="my-content">
        <div className="row">
          <div className="col-12 ">
            <div className="cause-wrap">
              <div className="cause-content-wrap">
                <div className="flex-c entry-content">
                  <form className="flex-col-gap-16" onSubmit={handleSubmit}>
                    <h1>Add Agent</h1>
                    <input type="text" className="form-control" name="first_name" placeholder="First name" minLength="3" maxLength="50"
                      value={formData["first_name"]} onChange={e => setFormData({...formData, first_name: e.target.value})} required />
                    
                    <input type="text" className="form-control" name="last_name" placeholder="Last name" minLength="3" maxLength="50"
                      value={formData["last_name"]} onChange={e => setFormData({...formData, last_name: e.target.value})} required />
                    
                    <input type="text" className="form-control" name="middle_name" placeholder="Middle name" minLength="2" maxLength="50"
                      value={formData["middle_name"]} onChange={e => setFormData({...formData, middle_name: e.target.value})}  />
                    
                    <input type="email" className="form-control" name="email" placeholder="Email"
                      value={formData["email"]} onChange={e => setFormData({...formData, email: e.target.value})} required />
                    
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                      <div className="agent-mobile-prefix">
                        <input type="text" className="form-control" name="mobile_prefix" placeholder="Mobile Prefix" minLength="2" maxLength="5"
                          value={`+${formData["mobile_prefix"]}`} onChange={() => {}}  disabled />
                      </div>

                      <div className="agent-mobile-suffix">
                        <input type="text" className="form-control" name="mobile_number" placeholder="Mobile Number" minLength="9" maxLength="20"
                          value={formData["mobile_number"]} onChange={e => setFormData({...formData, mobile_number: e.target.value})} required/>
                      </div>
                    </div>
                    <select 
                      style={{padding: "8px 4px", 
                      marginBottom: "24px", width: "100%"}} 
                      class="form-select" 
                      aria-label="Default select example"
                      onChange={(e) => setFormData({...formData, location: e.target.value})}
                      value={formData["location"]}
                      required
                    >
                      {locations.map((location) => {
                        return (
                            <option key={location.key} value={location.value} selected={location.value === ""} disabled={location.value === ""}>{location.key}</option>
                        )
                      })}
                    </select>
                    <button className="btn btn-primary mb-2" type="submit" disabled={loading}>{loading ? "Loading" : "Submit"}</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddAgentForm;